import { render, staticRenderFns } from "./ParametriImpianto.vue?vue&type=template&id=37f7ffa8&"
import script from "./ParametriImpianto.vue?vue&type=script&lang=js&"
export * from "./ParametriImpianto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports